export default __webpack_public_path__ + "static/media/frequent_spenders.234e4d74.svg";